export interface EnvironmentConfig {
  environment: "dev" | "qa" | "prod";
  clientId: string;
  buildNumber: string;
  authority: string;
  apiBaseUrl: string;
}

export interface InternalEnvironmentConfig extends EnvironmentConfig {
  localDevelopmentMode?: boolean;
}

const environments: EnvironmentConfig["environment"][] = ["dev", "qa", "prod"];

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
const actualConfig: EnvironmentConfig | undefined = (window as any).configuration;

const defaultConfig: EnvironmentConfig = {
  environment: "dev",
  clientId: "agent_pwa",
  buildNumber: "localDevelopment",
  authority: "https://geoauth-qa.geomant.cloud",
  apiBaseUrl: "https://api-dev.geomant.cloud",
};

const usedConfig = actualConfig && environments.includes(actualConfig.environment)
  ? actualConfig
  : defaultConfig;

const usedInternalConfig: InternalEnvironmentConfig = {
  ...usedConfig,
  localDevelopmentMode: window.location.hostname === "localhost",
};

export default Object.freeze(usedInternalConfig);
